import { Breakpoint, Color, Typography } from '@elearning-platform/ui';
import { styled } from 'styled-components';

export const Wrapper = styled.div`
  width: 100%;
  padding: 24px 16px;
  background-color: ${Color.Gray100};

  @media ${Breakpoint.SmallDesktop} {
    padding: 50px;
  }
`;

export const GridContainer = styled.div`
  width: 100%;
  max-width: 1280px;
  display: grid;
  grid-template-columns: 1fr auto;
  grid-template-rows: 100px minmax(349px, 1fr) min-content;
  padding: 40px 16px;

  @media ${Breakpoint.SmallDesktop} {
    grid-template-columns: 50% 1fr 1fr;
    grid-template-rows: 133px 1fr min-content;
  }

  @media ${Breakpoint.Tablet} {
    padding: 0;
  }
`;

export const MobileShape = styled.img`
  width: 100%;
  height: 100%;
  display: block;
`;

export const DesktopShape = styled.img``;

export const EmptyShape = styled.div`
  border: 1px solid ${Color.Gray300};
  border-bottom: none;
  border-right: none;

  @media ${Breakpoint.SmallDesktop} {
    border-right: 1px solid ${Color.Gray300};
    grid-column: 1 / 3;
  }
`;

export const ContentContainer = styled.div`
  grid-column: 1 / 3;
  display: flex;
  flex-direction: column;
  justify-content: center;
  gap: 24px;
  padding: 64px 20px;
  border: 1px solid ${Color.Gray300};

  @media ${Breakpoint.SmallDesktop} {
    padding: 30px 50px;
    border-right: none;
  }
`;

export const Title = styled(Typography)`
  color: ${Color.Gray800};
`;

export const SupportingText = styled(Typography)`
  color: ${Color.Gray700};
`;

export const ButtonWrapper = styled.div`
  display: flex;
  border: 1px solid ${Color.Gray300};
  border-top: none;
  padding: 20px;
  grid-column: 1 / -1;

  @media ${Breakpoint.SmallDesktop} {
    grid-column: 1 / 3;
    padding: 29px 34px;
  }
`;
